import Text from '../../atoms/text';

const SectionHeader = ({ title }: { title: string }) => (
	<Text
		className="w-full text-white bg-primary text-center font-semibold py-1 rounded-t-md"
		as="h5"
	>
		{title}
	</Text>
);

export default SectionHeader;
